// hidden md:flex items-center

import { useContext, type ReactElement } from "react"
import { Link, useLocation } from "react-router"
import SiteContext from "@/state/SiteContext"

function Nav({ scrolled = false, show = false }: { scrolled: boolean, show: boolean }): ReactElement {
  const location = useLocation()
  const siteContext = useContext(SiteContext)
  if (siteContext === undefined) {
    return (<></>)
  }
  const linkClassName = 'block py-2 mr-4 font-semibold text-[var(--color-primary-darker)] transition-all duration-100'
  const linkClassNameScrolled = 'md:text-xs block py-2 mr-4 font-semibold text-[var(--color-primary-darker)] transition-all duration-100'
  return (<div className={`${show ? 'block' : 'hidden'} lg:flex items-center`}>{
    siteContext.header.menus.map((item) => {
      const selected = location.pathname.search(item.to) === 0

      return <Link key={item.label} to={item.to} target={item.target ?? undefined} className={`${scrolled ? linkClassNameScrolled : linkClassName}${selected ? ' underline underline-offset-8' : ''}`}>{item.label}</Link>
    })}</div>)
}

export default Nav